module.exports = __webpack_public_path__ + "img/ac13.7c2ad6a3.jpg";